// src/Pages/Home/Carrousel.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Carrousel.css';
import { IMAGES } from '../../config/supabaseImages';
import BrandArrow from '../../Components/ui/BrandArrow';
import { getSiteAsset, useSiteAssets } from '../../utils/useSiteAssets';

const PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600"><rect width="100%" height="100%" fill="#f3f4f6"/><text x="50%" y="50%" fill="#9ca3af" font-family="Arial, sans-serif" font-size="20" dominant-baseline="middle" text-anchor="middle">Imagen no disponible</text></svg>`
  );

// ── Flechas custom (mismo naming que el resto: instagram-carousel-*) ──
// ── Flechas custom (mismo naming que el resto: instagram-carousel-*) ──
const PrevArrow = ({ onClick }) => (
  <button
    type="button"
    className="instagram-carousel-arrow instagram-carousel-arrow--prev"
    onClick={onClick}
    aria-label="Anterior"
  >
    <BrandArrow />
  </button>
);

const NextArrow = ({ onClick }) => (
  <button
    type="button"
    className="instagram-carousel-arrow instagram-carousel-arrow--next"
    onClick={onClick}
    aria-label="Siguiente"
  >
    <BrandArrow direction="up-right" />
  </button>

);

const Carousel = () => {
  const assets = useSiteAssets();

  // numero = slot en site_assets (carrusel.N), palabra = clave historica en supabaseImages.
  const getImg = (numero, palabra) => {
    const candidates = [
      getSiteAsset(assets, `carrusel.${numero}`),
      IMAGES?.carousel?.[palabra],
      IMAGES?.[palabra],
      IMAGES?.home?.[palabra],
      IMAGES?.inspiration?.[palabra],
      IMAGES?.frases?.[palabra],
      PLACEHOLDER
    ];
    return candidates.find(Boolean) || PLACEHOLDER;
  };

  const getAlt = (numero, fallback) => assets[`carrusel.${numero}`]?.alt || fallback;

  const carouselImages = [
    { numero: 1,  src: getImg(1,  'guitarra'),      alt: getAlt(1,  'Portfolio guitarra') },
    { numero: 2,  src: getImg(2,  'trece'),         alt: getAlt(2,  'Portfolio trece') },
    { numero: 3,  src: getImg(3,  'jp'),            alt: getAlt(3,  'Portfolio jp') },
    { numero: 4,  src: getImg(4,  'rosa'),          alt: getAlt(4,  'Portfolio rosa') },
    { numero: 5,  src: getImg(5,  'carting'),       alt: getAlt(5,  'Portfolio carting') },
    { numero: 6,  src: getImg(6,  'ramo'),          alt: getAlt(6,  'Portfolio ramo') },
    { numero: 7,  src: getImg(7,  'chicaCaballo'),  alt: getAlt(7,  'Portfolio chica y caballo') },
    { numero: 8,  src: getImg(8,  'boina'),         alt: getAlt(8,  'Portfolio boina') },
    { numero: 9,  src: getImg(9,  'flia'),          alt: getAlt(9,  'Portfolio familia') },
    { numero: 10, src: getImg(10, 'faro'),          alt: getAlt(10, 'Portfolio faro') },
    { numero: 11, src: getImg(11, 'montana'),       alt: getAlt(11, 'Portfolio montaña') },
    { numero: 12, src: getImg(12, 'caballo'),       alt: getAlt(12, 'Portfolio caballo') },
    { numero: 13, src: getImg(13, 'silla'),         alt: getAlt(13, 'Portfolio silla') },
    { numero: 14, src: getImg(14, 'reja'),          alt: getAlt(14, 'Portfolio reja') },
    { numero: 15, src: getImg(15, 'lu'),            alt: getAlt(15, 'Portfolio lu') },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 450,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    vertical: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    centerMode: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } }
    ]
  };

  const handleImgError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = PLACEHOLDER;
    e.currentTarget.alt = 'Imagen no disponible';
  };

  return (
    <div className="instagram-carousel-container">
      <Slider {...settings}>
        {carouselImages.map((image) => (
          <div key={image.numero} className="instagram-carousel-item">
            <div className="instagram-image-wrapper">
              <img
                src={image.src}
                alt={image.alt}
                className="instagram-carousel-image"
                loading="lazy"
                decoding="async"
                onError={handleImgError}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;